export const colors = {
  primary: '#1890ff',
  success: '#52c41a',
  warning: '#faad14',
  error: '#ff4d4f',
  heading: 'rgba(255, 255, 255, 0.85)',
  text: 'rgba(255, 255, 255, 0.65)',
  textSecondary: 'rgba(255, 255, 255, 0.45)',
  disabled: 'rgba(255, 255, 255, 0.25)',
  border: '#434343',
  background: '#262626',
  componentBackground: '#141414',
  bodyBackground: '#000', // pure black for body
  layoutBodyBackground: '#141414', // slightly lighter for layout components
};

export const palette = {
  primary: [
    '#e6f7ff', // 0: lightest (backgrounds)
    '#91d5ff', // 1: light (borders/hover)
    '#1890ff', // 2: main
    '#096dd9', // 3: dark (active)
    '#0050b3', // 4: darkest (text/stress)
  ],
  success: [
    '#f6ffed',
    '#b7eb8f',
    '#52c41a',
    '#389e0d',
    '#237804',
  ],
  warning: [
    '#fffbe6',
    '#ffe58f',
    '#faad14',
    '#d48806',
    '#ad6800',
  ],
  error: [
    '#fff1f0',
    '#ffccc7',
    '#ff4d4f',
    '#d9363e',
    '#a8071a',
  ],
};

const themeConfig = {
  colors,
  palette
};

export default themeConfig;
